import { Onetrust } from './onetrust';

export const OnetrustClient = Onetrust.instance;
